import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

import Toast from '../../../component/Toast'

import CD from 'src/component/CountDown'
import Header from '../../../component/Header'
import RuleButton from '../../../component/RuleButton'
import DropScreen from '../nationalTemplate/DropScreen'

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.ramadan = this.props.store.register('activity/ramadan')
    setDocumentTitle("Ramadan")
  }

  state = {
    lang: langM.ar,
    tabStatus: 1,
    tab2Status: 2,
    cd: 0,
    rewardList: [],
    taskList: [],
    thisWeeekRank: [],
    lastWeeekRank: [],
    thisMyRank: {},
    desc: null,
    language:'en',
  }

  async componentWillMount() {
    // 控制台调试
    // ()

    let { language } = this.props.location.query
    language =await getlang(language)
    console.log('language', language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    await this.RunOnStart(uid)
    await this.ramadan.GetUserInfoWeb(uid)
    let cd = await this.ramadan.getCd()
    let rewardList = await this.ramadan.getRewardList()
    let taskList = await this.ramadan.getTask()
    console.log(rewardList, 'rewardList')
    console.log(taskList, 'taskList')
    console.log(cd, 'cd')

    let rankThisWeek = await this.ramadan.getRank(0)
    let rankLastWeek = await this.ramadan.getRank(7)
    console.log(rankThisWeek, 'rankThisWeek')
    console.log(rankLastWeek, 'rankLastWeek')

    this.setState({
      cd: cd,
      rewardList: rewardList,
      taskList: taskList,
      thisWeeekRank: rankThisWeek && rankThisWeek.list,
      lastWeeekRank: rankLastWeek && rankLastWeek.list,
      thisMyRank: rankThisWeek && rankThisWeek.myrank
    })
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })
  }

  componentDidMount() {
    this.$logEvent('ramadan_main_screen')
  }



  timeComp({ langtxt, daytxt, day, hour, mi, se }) {
    return (
      <div className="timer">
        <div className="star"></div>
        <div className="d time-box">
          {day}
        </div>
        <div className="d time-box">
          Day
        </div>
        <div className="h time-box">
          {hour}
        </div>
        <div>
          :
        </div>
        <div className="m time-box">
          {mi}
        </div>
        <div>
          :
        </div>
        <div className="s time-box">
          {se}
        </div>
      </div>
    )
  }

  ruleContentComp(open, close, lang) {
    return (
      <div className="eid-day-rule-main" onClick={() => { close() }}>
        <div className="eid-day-rule-title">
          {lang.rules}
        </div>
        <div className="eid-day-rule-wrap" dangerouslySetInnerHTML={{ __html: lang.ruleTxt }}></div>
      </div>
    )
  }


  async onTask1(state, tId, type) {
    if(type =="1W"){
      this.$logEvent("ramadan_get_10K")
    }
    if(type =="10W"){
      this.$logEvent("ramadan_get_100K")
    }
    if(type =="20W"){
      this.$logEvent("ramadan_get_200K")
    }
    if(type =="70W"){
      this.$logEvent("ramadan_get_700K")
    }
    if(type =="120W"){
      this.$logEvent("ramadan_get_1200K")
    }
    // 可领取
    if (state == 1) {
      try {
        let res = await this.ramadan.getReward(tId)
        let taskList = await this.ramadan.getTask()
        this.setState({
          desc: this.state.lang.sucGet,
          taskList: taskList
        })
        this.refs.toast.hideRule(true)
      } catch (error) {
        this.setState({
          desc: error
        })
        this.refs.toast.hideRule(true)
      }
    }
    // 已领取
    if (state == 2) {
      this.setState({
        desc: this.state.lang.hadGet
      })
      this.refs.toast.hideRule(true)
    }
    // 领取
    if (state == 3) {
      this.setState({
        desc: this.state.lang.noDone
      })
      this.refs.toast.hideRule(true)
    }
  }

  taskComp() {
    const task1 = this.state.taskList && this.state.taskList[0]
    const task1val = task1 && task1.val
    const task1condition = task1 && task1.condition
    const task1Pro = 100 - ((task1val / task1condition) * 100)
    const task1List = task1 && task1.list

    const task2 = this.state.taskList && this.state.taskList[1]
    const task2val = task2 && task2.val
    const task2condition = task2 && task2.condition
    const task2Pro = 100 - ((task2val / task2condition) * 100)
    const task2List = task2 && task2.list

    const task3 = this.state.taskList && this.state.taskList[2]
    const task3val = task3 && task3.val
    const task3condition = task3 && task3.condition
    const task3Pro = 100 - ((task3val / task3condition) * 100)
    const task3List = task3 && task3.list

    const task4 = this.state.taskList && this.state.taskList[3]
    const task4val = task4 && task4.val
    const task4condition = task4 && task4.condition
    const task4Pro = 100 - ((task4val / task4condition) * 100)
    const task4List = task4 && task4.list

    const task5 = this.state.taskList && this.state.taskList[4]
    const task5val = task5 && task5.val
    const task5condition = task5 && task5.condition
    const task5Pro = 100 - ((task5val / task5condition) * 100)
    const task5List = task5 && task5.list


    return (
      <div className="eid-day-task-main"
        style={{ display: `${this.state.tabStatus == 2 ? "block" : "none"}` }}>
        <div className="eid-day-task-wrap">

          <div className="eid-day-task-item">
            <div className="eid-day-task-item-title">{this.state.lang.sendGold(task1 && task1.condition)}</div>
            <div className="eid-day-task-item-pro">
              <div className="eid-day-task-item-pro-box">
                <div className="progress">{task1val}</div>
                <div className="eid-day-task-item-pro-item" style={{ transform: `translateX(-${task1Pro}%)` }}></div>
              </div>
            </div>
            <div className="eid-day-task-item-content">
              {
                task1 && task1.list.map((item, index) => {
                  return (
                    <div className="eid-day-task-rw-item" key={index}>
                      <div className="eid-day-task-rw-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="eid-day-task-rw-txt">{item.name}</div>
                    </div>
                  )
                })
              }

            </div>
            {
              task1 && task1.canGet && task1.isGet == false && (<div className="eid-day-task-item-button eid-day-task-item-button-active" onClick={() => { this.onTask1(1, task1 && task1.taskid, "1W") }}>{this.state.lang.CanGet}</div>)
            }
            {
              task1 && task1.canGet == false && task1.isGet && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(2, task1 && task1.taskid, "1W") }}>{this.state.lang.hadGet}</div>)
            }
            {
              task1 && task1.canGet == false && task1.isGet == false && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(3, task1 && task1.taskid, "1W") }}>{this.state.lang.get}</div>)
            }
          </div>
          <div className="eid-day-task-item">
            <div className="eid-day-task-item-title">{this.state.lang.sendGold(task2 && task2.condition)}</div>
            <div className="eid-day-task-item-pro">
              <div className="eid-day-task-item-pro-box">
                <div className="progress">{task2val}</div>
                <div className="eid-day-task-item-pro-item" style={{ transform: `translateX(-${task2Pro}%)` }}></div>
              </div>
            </div>
            <div className="eid-day-task-item-content">
              {
                task2 && task2.list.map((item, index) => {
                  return (
                    <div className="eid-day-task-rw-item" key={index}>
                      <div className="eid-day-task-rw-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="eid-day-task-rw-txt">{item.name}</div>
                    </div>
                  )
                })
              }

            </div>
            {
              task2 && task2.canGet && task2.isGet == false && (<div className="eid-day-task-item-button eid-day-task-item-button-active" onClick={() => { this.onTask1(1, task2 && task2.taskid, "10W") }}>{this.state.lang.CanGet}</div>)
            }
            {
              task2 && task2.canGet == false && task2.isGet && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(2, task2 && task2.taskid, "10W") }}>{this.state.lang.hadGet}</div>)
            }
            {
              task2 && task2.canGet == false && task2.isGet == false && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(3, task2 && task2.taskid, "10W") }}>{this.state.lang.get}</div>)
            }
          </div>


          <div className="eid-day-task-item2">
            <div className="eid-day-task-item-title">{this.state.lang.sendGold(task3 && task3.condition)}</div>
            <div className="eid-day-task-item-pro">
              <div className="eid-day-task-item-pro-box">
                <div className="progress">{task3val}</div>
                <div className="eid-day-task-item-pro-item" style={{ transform: `translateX(-${task3Pro}%)` }}></div>
              </div>
            </div>
            <div className="eid-day-task-item-content">
              {
                task3 && task3.list.map((item, index) => {
                  return (
                    <div className="eid-day-task-rw-item" key={index}>
                      <div className="eid-day-task-rw-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="eid-day-task-rw-txt">{item.name}</div>
                    </div>
                  )
                })
              }

            </div>
            {
              task3 && task3.canGet && task3.isGet == false && (<div className="eid-day-task-item-button eid-day-task-item-button-active" onClick={() => { this.onTask1(1, task3 && task3.taskid, "20W") }}>{this.state.lang.CanGet}</div>)
            }
            {
              task3 && task3.canGet == false && task3.isGet && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(2, task3 && task3.taskid, "20W") }}>{this.state.lang.hadGet}</div>)
            }
            {
              task3 && task3.canGet == false && task3.isGet == false && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(3, task3 && task3.taskid, "20W") }}>{this.state.lang.get}</div>)
            }
          </div>
          <div className="eid-day-task-item2">
            <div className="eid-day-task-item-title">{this.state.lang.sendGold(task4 && task4.condition)}</div>
            <div className="eid-day-task-item-pro">
              <div className="eid-day-task-item-pro-box">
                <div className="progress">{task4val}</div>
                <div className="eid-day-task-item-pro-item" style={{ transform: `translateX(-${task4Pro}%)` }}></div>
              </div>
            </div>
            <div className="eid-day-task-item-content">
              {
                task4 && task4.list.map((item, index) => {
                  return (
                    <div className="eid-day-task-rw-item" key={index}>
                      <div className="eid-day-task-rw-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="eid-day-task-rw-txt">{item.name}</div>
                    </div>
                  )
                })
              }
            </div>
            {
              task4 && task4.canGet && task4.isGet == false && (<div className="eid-day-task-item-button eid-day-task-item-button-active" onClick={() => { this.onTask1(1, task4 && task4.taskid, "70W") }}>{this.state.lang.CanGet}</div>)
            }
            {
              task4 && task4.canGet == false && task4.isGet && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(2, task4 && task4.taskid, "70W") }}>{this.state.lang.hadGet}</div>)
            }
            {
              task4 && task4.canGet == false && task4.isGet == false && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(3, task4 && task4.taskid, "70W") }}>{this.state.lang.get}</div>)
            }
          </div>
          <div className="eid-day-task-item2">
            <div className="eid-day-task-item-title">{this.state.lang.sendGold(task5 && task5.condition)}</div>
            <div className="eid-day-task-item-pro">
              <div className="eid-day-task-item-pro-box">
                <div className="progress">{task5val}</div>
                <div className="eid-day-task-item-pro-item" style={{ transform: `translateX(-${task5Pro}%)` }}></div>
              </div>
            </div>
            <div className="eid-day-task-item-content">
              {
                task5 && task5.list.map((item, index) => {
                  return (
                    <div className="eid-day-task-rw-item" key={index}>
                      <div className="eid-day-task-rw-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="eid-day-task-rw-txt">{item.name}</div>
                    </div>
                  )
                })
              }

            </div>
            {
              task5 && task5.canGet && task5.isGet == false && (
                <div className="eid-day-task-item-button eid-day-task-item-button-active" onClick={() => { this.onTask1(1, task5 && task5.taskid, "120W") }}>
                  {this.state.lang.CanGet}
                </div>)
            }
            {
              task5 && task5.canGet == false && task5.isGet && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(2, task5 && task5.taskid, "120W") }}>
                {this.state.lang.hadGet}
              </div>)
            }
            {
              task5 && task5.canGet == false && task5.isGet == false && (<div className="eid-day-task-item-button" onClick={() => { this.onTask1(3, task5 && task5.taskid, "120W") }}>
                {this.state.lang.get}
              </div>)
            }
          </div>
        </div>
      </div>
    )
  }

  rewardComp() {
    const rwList = [
      {
        title: 'TOP1',
        list: [
          {
            img: "/img/activity/ramadan/reward/m/m1.png",
            name: "Medal 1year (score>1.5M)"
          },
          {
            img: "/img/activity/ramadan/reward/h/h1.png",
            name: "Head 1month"
          },
          {
            img: "/img/activity/ramadan/reward/c/c1.png",
            name: "Car 1month"
          },
          {
            img: "/img/activity/ramadan/reward/gift.png",
            name: "Gift 7days"
          },
          {
            img: "/img/activity/ramadan/reward/f2.png",
            name: "Screen 7days"
          },
          {
            img: "/img/gold.png",
            name: "Gold 200K (score>1M)"
          },
        ]
      },
      {
        title: 'TOP2',
        list: [
          {
            img: "/img/activity/ramadan/reward/m/m2.png",
            name: "Medal 1year (score>500K)"
          },
          {
            img: "/img/activity/ramadan/reward/h/h2.png",
            name: "Head 1month"
          },
          {
            img: "/img/activity/ramadan/reward/c/c2.png",
            name: "Car 1month"
          },
          {
            img: "/img/activity/ramadan/reward/f2.png",
            name: "Screen 7days"
          },
          {
            img: "/img/gold.png",
            name: "Gold 100K (score>500K)"
          },
        ]
      },
      {
        title: 'TOP3',
        list: [
          {
            img: "/img/activity/ramadan/reward/m/m3.png",
            name: "Medal 1year (score>250K)"
          },
          {
            img: "/img/activity/ramadan/reward/h/h3.png",
            name: "Head 1month"
          },
          {
            img: "/img/activity/ramadan/reward/c/c3.png",
            name: "Car 1month"
          },
          {
            img: "/img/activity/ramadan/reward/f2.png",
            name: "Screen 7days"
          },
          {
            img: "/img/gold.png",
            name: "Gold 70K (score>250K)"
          },
        ]
      },
    ]

    return (
      <div
        style={{ display: `${this.state.tab2Status == 3 && this.state.tabStatus == 1 ? "block" : "none"}` }}
        className="eid-day-reward-main"
      >
        <div className="eid-day-reward-wrap">
          <div className="eid-day-reward-top"></div>
          <div className="eid-day-reward-center">
            {
              rwList.map((item, index) => {
                return (
                  <div className="eid-day-reward-center-item">
                    <div className="eid-day-reward-center-item-title">{item.title}</div>
                    <div className="eid-day-reward-center-item-content">
                      {item.list.map((item2, index2) => {
                        return (
                          <div className="eid-day-reward-center-item-content-item">
                            <div className="eid-day-reward-center-item-content-item-img">
                              <img src={item2.img} alt="" />
                            </div>
                            <div className="eid-day-reward-center-item-content-item-txt">
                              {item2.name}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div className="eid-day-reward-bottom"></div>
        </div>
      </div>
    )
  }
  lastWeekComp() {
    const top1 = this.state.lastWeeekRank && this.state.lastWeeekRank[0]
    const top2 = this.state.lastWeeekRank && this.state.lastWeeekRank[1]
    const top3 = this.state.lastWeeekRank && this.state.lastWeeekRank[2]
    return (
      <div
        className="eid-day-last-week-main"
        style={{ display: `${this.state.tab2Status == 1 && this.state.tabStatus == 1 ? "block" : "none"}` }}
      >
        <div className="eid-day-last-week-wrap">
          <div className="eid-day-last-week-top1">
            <Header
              userOrRoom={"user"}
              userId={top1 && top1.uid}
              userAvatar={top1 && top1.avatarurl}
              scaleSize={1.1}
              headWear={"/img/activity/ramadan/head/h1.png"}
            />
            <div className="eid-day-last-week-top1-name">
              {top1 && top1.nickname}
            </div>
            <div className="eid-day-last-week-top1-id">
              ID:{top1 && top1.duid}
            </div>
            <div className="eid-day-last-week-top1-gold">
              <img src="/img/gold.png" alt="" />
              <span>{score(top1 && top1.value)}</span>
            </div>
          </div>
          <div className="eid-day-last-week-top23">
            <div className="eid-day-last-week-top2">
              <Header
                userOrRoom={"user"}
                userId={top2 && top2.uid}
                userAvatar={top2 && top2.avatarurl}
                scaleSize={0.9}
                headWear={"/img/activity/ramadan/head/h2.png"}
              />
              <div className="eid-day-last-week-top2-name">
                {top2 && top2.nickname}
              </div>
              <div className="eid-day-last-week-top2-id">
                ID:{top2 && top2.duid}
              </div>
              <div className="eid-day-last-week-top2-gold">
                <img src="/img/gold.png" alt="" />
                <span>{score(top2 && top2.value)}</span>
              </div>
            </div>
            <div className="eid-day-last-week-top3">
              <Header
                userOrRoom={"user"}
                userId={top3 && top3.uid}
                userAvatar={top3 && top3.avatarurl}
                scaleSize={0.9}
                headWear={"/img/activity/ramadan/head/h3.png"}
              />
              <div className="eid-day-last-week-top3-name">
                {top3 && top3.nickname}
              </div>
              <div className="eid-day-last-week-top3-id">
                ID:{top3 && top3.duid}
              </div>
              <div className="eid-day-last-week-top3-gold">
                <img src="/img/gold.png" alt="" />
                <span>{score(top3 && top3.value)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  weekRankComp() {
    const top1 = this.state.thisWeeekRank && this.state.thisWeeekRank[0]
    const top2 = this.state.thisWeeekRank && this.state.thisWeeekRank[1]
    const top3 = this.state.thisWeeekRank && this.state.thisWeeekRank[2]
    return (
      <div
        style={{ display: `${this.state.tab2Status == 2 && this.state.tabStatus == 1 ? "block" : "none"}` }}
        className="eid-day-rank-main">
        <div className="eid-day-rank-wrap">
          <div className="eid-day-rank-top">
            <div className="top1">
              <Header
                userOrRoom={"user"}
                userId={top1 && top1.uid}
                userAvatar={top1 && top1.avatarurl}
                scaleSize={1.1}
                headWear={"/img/activity/ramadan/head/h1.png"}
              />
              <div className="name">{top1 && top1.nickname}</div>
              <div className="id">ID:{top1 && top1.duid}</div>
              <div className="gold">
                <img src="/img/gold.png" alt="" />
                <span>{score(top1 && top1.value)}</span>
              </div>
            </div>
            <div className="top23">
              <div className="top2">
                <Header
                  userOrRoom={"user"}
                  userId={top2 && top2.uid}
                  userAvatar={top2 && top2.avatarurl}
                  scaleSize={0.9}
                  headWear={"/img/activity/ramadan/head/h2.png"}
                />
                <div className="name">{top2 && top2.nickname}</div>
                <div className="id">ID:{top2 && top2.duid}</div>
                <div className="gold">
                  <img src="/img/gold.png" alt="" />
                  <span>{score(top2 && top2.value)}</span>
                </div>
              </div>
              <div className="top3">
                <Header
                  userOrRoom={"user"}
                  userId={top3 && top3.uid}
                  userAvatar={top3 && top3.avatarurl}
                  scaleSize={0.9}
                  headWear={"/img/activity/ramadan/head/h3.png"}
                />
                <div className="name">{top3 && top3.nickname}</div>
                <div className="id">ID:{top3 && top3.duid}</div>
                <div className="gold">
                  <img src="/img/gold.png" alt="" />
                  <span>{score(top3 && top3.value)}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="eid-day-rank-center">
            {
              this.state.thisWeeekRank && this.state.thisWeeekRank.map((item, index) => {
                if (index > 2) {
                  return (
                    <div className="eid-day-rank-center-item" key={index}>
                      <div className="rank">{item && item.rank || 0}</div>
                      <div className="ava" onClick={() => jumpToUser(item && item.uid)}>
                        <img src={item && item.avatarurl} alt="" />
                      </div>
                      <div className="info">
                        <div className="name">{item && item.nickname}</div>
                        <div className="id">ID:{item && item.duid}</div>
                      </div>
                      <div className="gold">
                        <span>{score(item && item.value)}</span>
                        <img src="/img/gold.png" alt="" />
                      </div>
                    </div>
                  )
                }
              })
            }

          </div>
          <div className="eid-day-rank-bottom"></div>
        </div>
      </div>
    )
  }
  myRankComp() {
    const myRank = this.state.thisMyRank
    return (
      <div className="eid-day-myrank" style={{ display: `${this.state.tab2Status == 2 && this.state.tabStatus == 1 ? "flex" : "none"}` }}>
        <div className="rank">{myRank && myRank.rank}</div>
        <div className="ava" onClick={() => { jumpToUser(myRank && myRank.uid) }}>
          <img src={myRank && myRank.avatarurl} alt="" />
        </div>
        <div className="info">
          <div className="name">{myRank && myRank.nickname}</div>
          <div className="id">ID:{myRank && myRank.duid}</div>
        </div>
        <div className="gold">
          <img src="/img/gold.png" alt="" />
          <span>{score(myRank && myRank.value)}</span>
        </div>
      </div>
    )
  }


  onChangeTab(v) {
    this.setState({
      tabStatus: v
    })
  }
  onChangeTab2(v) {
    if (v == 1) {
      this.$logEvent('ramadan_lastweek_rank')
    }
    if (v == 2) {
      this.$logEvent('ramadan_thisweek_rank')
    }
    if (v == 3) {
      this.$logEvent('ramadan_reward')
    }
    this.setState({
      tab2Status: v
    })
  }

  render() {

    return (
      <div className={`eid-day-wrap-main ${this.state.language == 'ar' ? "lang-ar" : ""}`}>


        <DropScreen image={"/img/activity/ramadan/reward/f3.png"} />
        <Toast ref="toast" toastContent={this.state.desc} />

        {/* banner */}
        <div className="eid-day-banner-main">
          <div className="eid-day-banner-star"></div>
          <div className="eid-day-banner-star2"></div>
          <div className="eid-day-banner-flower"></div>
          <div className="eid-day-banner-small"></div>
          <div className="eid-day-banner-big"></div>
          <div className="eid-day-banner-small2"></div>
          <div className="eid-day-banner-big2"></div>
          <span onClick={() => { this.$logEvent('ramadan_rule') }}>
            <RuleButton
              lang={this.state.lang}
              slotButtonComp={() => { return (<div className="eid-day-banner-rule">{this.state.lang.rules}</div>) }}
              slotContentComp={this.ruleContentComp} />
          </span>
        </div>

        {/* 倒计时 */}
        <div className="eid-day-cd-main"><CD leftTimestamp={this.state.cd} slot={this.timeComp} /></div>

        {/* 活动礼物 */}
        <div className="eid-day-activity-gift-main">
          <div className="eid-day-activity-gift-wrap">
            <div className="eid-day-activity-gift-title">{this.state.lang.gift}</div>
            <div className="eid-day-activity-gift-content">
              {
                this.state.rewardList && this.state.rewardList.map((item, index) => {
                  return (
                    <div className="eid-day-activity-gift-content-item" key={index}>
                      <div className="gift-box">
                        <div className="star"></div>
                        <img className='tran3D' src={item.image} alt="" />
                      </div>
                      <div className="gift-name">
                        <span>
                          <img src="/img/gold.png" alt="" />{item.gold}
                        </span>
                        <span>
                          {item.name}
                        </span>
                      </div>
                    </div>
                  )
                })
              }

            </div>
          </div>
        </div>

        <div className="screen-fall" style={{ direction: `${this.state.language == 'ar' ? "rtl" : "ltr"}` }}>
          <div className="screen-fall-item fall">
            <img src="/img/activity/ramadan/reward/f1.png" alt="" />
            <span>{this.state.lang.text}</span>
          </div>
          <div className="screen-fall-item">
            <img src="/img/activity/ramadan/reward/f2.png" alt="" />
            <span>{this.state.lang.moon}</span>
          </div>
        </div>

        {/* 切换栏 */}
        <div className="eid-day-tab-main">
          <div className="eid-day-tab-wrap">
            <div className={`eid-day-tab-item ${this.state.tabStatus == 1 ? "eid-day-tab-item-active" : ""}`} onClick={() => { this.onChangeTab(1) }}>{this.state.lang.rank}</div>
            <div className={`eid-day-tab-item ${this.state.tabStatus == 2 ? "eid-day-tab-item-active" : ""}`} onClick={() => { this.onChangeTab(2) }}>{this.state.lang.task}</div>
          </div>
          <div className="eid-day-tab2-wrap" style={{ display: `${this.state.tabStatus == 1 ? "flex" : "none"}` }}>
            <div className={`eid-day-tab2-item ${this.state.tab2Status == 1 ? "eid-day-tab2-item-active" : ""}`} onClick={() => { this.onChangeTab2(1) }}>{this.state.lang.lastW}</div>
            <div className={`eid-day-tab2-item ${this.state.tab2Status == 2 ? "eid-day-tab2-item-active" : ""}`} onClick={() => { this.onChangeTab2(2) }}>{this.state.lang.thisW}</div>
            <div className={`eid-day-tab2-item ${this.state.tab2Status == 3 ? "eid-day-tab2-item-active" : ""}`} onClick={() => { this.onChangeTab2(3) }}>{this.state.lang.rw}</div>
          </div>
        </div>

        {/* 任务 */}
        {this.taskComp()}

        {/* 奖励 */}
        {this.rewardComp()}

        {/* 上周 */}
        {this.lastWeekComp()}

        {/* 本周排行 */}
        {this.weekRankComp()}

        {/* 我的排行 */}
        {this.myRankComp()}

        <div className="eid-day-copyright">
          The copyright of this event belongs to App
        </div>

        {/* 资源 */}
        <div style={{ display: "none" }}>
          <img src="/img/activity/ramadan/rule_bg.png" alt="" />
        </div>
      </div >
    )
  }
}


// WEBPACK FOOTER //
// src/pages/activity/ramadan/index.js